import { clsx } from "clsx/lite"

import { PlainButtonLink } from "@/components/marketing/elements/button"
import { ArrowNarrowRightIcon } from "@/components/marketing/icons/arrow-narrow-right-icon"
import { docsUrl } from "@/lib/site-links"

/** In-body link out to the docs site, for the section that has just explained
 *  the model and left the reader wanting detail.
 *
 *  Deliberately plain rather than a filled button: the one primary CTA on
 *  every marketing page is `primaryCtaHref()`, and this must not compete with
 *  it. The negative margin cancels the button's own padding so the label lines
 *  up with the section copy above it. */
export function DocsCtaLink({ className }: { className?: string }) {
  return (
    <PlainButtonLink href={docsUrl} size="lg" className={clsx("-ml-4 self-start", className)}>
      Read the docs <ArrowNarrowRightIcon />
    </PlainButtonLink>
  )
}
